import React from 'react';
import { render } from "preact";
import {BaseComponent} from "../../../../project/general";
import {AHDropdown} from "../../search-filters/js/dropdown";


class AHSearchComponent extends BaseComponent {

    static getNamespace() {
        return 'ah-search';
    }

    static getRequiredRefs() {
        return [
            'action_url',
            'placeholder',
            'search_term'
        ]
    }

    toggleSearch = () => {
        let input = document.getElementById('searchTerm');
        let toggle = document.getElementById('search-action');
        let form = document.getElementById('searchForm');

        if(!input.classList.contains('search-active')) {
            toggle.classList.add('search-active');
            input.classList.add('search-active');

            input.focus();
        } else {
            if(input.value !== '') {
                form.submit();
            } else {
                toggle.classList.remove('search-active');
                input.classList.remove('search-active');

            }
        }
    }

    onInit() {
        let actionUrl = this.refs.action_url.value;
        let placeholder = this.refs.placeholder.value;
        let search_term = this.refs.search_term.value;

        render(
            <>
                <form id="searchForm" action={actionUrl} class="search-wrapper">
                    <label htmlFor="searchTerm" hidden></label>
                    <div className="search-input-wrapper">
                        <input id="searchTerm" type="text" name={search_term} placeholder={placeholder}/>
                    </div>
                    <svg id="search-action" onClick={() => {this.toggleSearch()}} aria-hidden="true">
                        <use xlinkHref="#icon-search"></use>
                    </svg>
                </form>

            </>,
            this.element
        )
    }

}

export default AHSearchComponent;
